import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { Formik } from 'formik';
import './RecommendationsModal.scss';
import Button from '../../../BaseComponents/Button';
import { getRecommendationsList } from '../../../../api/recommendation';
import { AssignRecommendationRequestPydantic } from '../../../../types/apiGeneratedTypes';
import { RecommendationsPageState } from '../../../../store/recommendationSlice';
import { setRecommendationsList, setMemberRecommendations } from '../../../../store/recommendationSlice';
import { toast } from 'react-toastify';
import Select from '../../../BaseComponents/Select';
import { assignRecommendationToMember } from '../../../../api/members';


type RecommendationsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

interface RecommendationFormValues {
  select_recommendation: number;
}

const RecommendationsModal: React.FC<RecommendationsModalProps> = ({
  isOpen, 
  onClose,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(false);
  const [error, setError] = useState<any>(null);
  const { memberData } = useSelector(
    (state: RootState) => state.member
  );
  const { recommendationToEdit, recommendationsList: allRecommendations, memberRecommendations: memberOnlyRecommendations } = useSelector(
    (state: RootState) => state.recommendations as RecommendationsPageState
  );

  const getDefaultValues = (): RecommendationFormValues => {
    if (recommendationToEdit) {
      const recommendationData = recommendationToEdit;
      if (recommendationData) {
        return {
          select_recommendation: Number(recommendationData.id),
        };
      }
    }
    return {
      select_recommendation: 0,
    };
  };

  const defaultValues = getDefaultValues();

  const filteredRecommendations = () => {
    return allRecommendations?.recommendations?.filter(rec => 
                !memberOnlyRecommendations?.recommendations?.find(memberRec => memberRec.id === rec.id)
              ).map(rec => ({
                key: rec.id,
                value: rec.title
              })) || []
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'Assign Recommendation'}
      memberName={memberData?.doctor ? `${memberData?.doctor?.first_name} ${memberData?.doctor?.last_name}` : ''}
      width={'800px'}
    >
      <Formik
        initialValues={defaultValues}
        onSubmit={async (values) => {
          setIsLoading(true);
          
          // Add safety check for memberData
          if (!memberData?.user_id) {
            console.error('memberData or user_id is missing:', memberData);
            toast.error('Member data not available');
            setIsLoading(false);
            return;
          }
          
          const requestObject: AssignRecommendationRequestPydantic = {
            recommendation_id: Number(values.select_recommendation),
            member_id: memberData.user_id,
          };
          
          console.log('Sending recommendation request:', requestObject);
          
          try {
            await assignRecommendationToMember(requestObject);
            // Refresh both lists
            const recommendationsList = await getRecommendationsList(0, 1000);
            const memberRecommendationsList = await getRecommendationsList(0, 1000, '', 'with_doctor_and_nutritionist', undefined, undefined, memberData.user_id);
            dispatch(setRecommendationsList(recommendationsList));
            dispatch(setMemberRecommendations(memberRecommendationsList));
            toast.success('Recommendation assigned successfully');
            onClose();
          } catch (error) {
            setError(error);
            toast.error('Error assigning recommendation');
          } finally {
            setIsLoading(false);
          }
        }}
      >
        {({ handleSubmit, values, setFieldValue }) => (
          <form onSubmit={handleSubmit} className='recommendation-modal-form'>
            <Select
              name='select_recommendation'
              title='Select recommendation *'
              placeholder='Choose recommendation'
              options={filteredRecommendations()}
              onChange={(option) => {
                setFieldValue('select_recommendation', option.key);
                setSelectedOption(option);
              }}
              selectedOption={selectedOption}
              isError={false}
              useMenuPortal
            />
            <div className='btn-wrapper'>
              <Button
                text='Assign Recommendation'
                type='submit'
                isDisabled={!values.select_recommendation}
                isLoading={isLoading}
              />
              {error && (
                <div className='error-message'>
                  Something went wrong. Please try again.
                </div>
              )}
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default RecommendationsModal;
